import { render, staticRenderFns } from "./applyDoc.vue?vue&type=template&id=6479f012"
import script from "./applyDoc.vue?vue&type=script&lang=js"
export * from "./applyDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports